export default {
  common: {
    esg: {
      category: 'Category',
      environment: 'Environment',
      society: 'Social',
      governance: 'Governance',
      other: 'Other',
      comprehensive: 'Total',
      basic: 'Basic Information',
    },
    btn: {
      cancel: 'Cancel',
      add: 'Add',
      create: 'Create',
      update: 'Update',
      apply: 'Apply',
      close: 'Close',
      create_new: 'Create new',
      edit: 'Edit',
      detail: 'Detail',
      view_detail: 'Detail',
      delete: 'Delete',
      change: 'Change',
      confirm: 'Confirm',
      clear: 'Reset',
      download: 'Download',
      save: 'Save',
      register: 'Register',
      send: '@:upload_common.send',
      check_answer: 'Check answer',
      score_card_list: 'Score card list',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
    },
    link: {
      delete: 'Delete',
      back: 'Back',
    },
    sentence: {
      back_to_login: 'Back to login',
      back_to_dashboard: 'Back to dashboard',
      not_applicable: 'Not applicable*',
      back_to_top: 'Go back to Top Page',
      send_the_following: 'Send the following content.',
      add_the_following: 'Add the following content.',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'Survey',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'Select a survey',
      target_year: 'Year',
      target_year_text: 'Select a year',
      target_company: 'Company',
      target_company_text: 'Select a company',
      total: 'All: {total}',
    },
    label: {
      required: 'Required',
      optional: 'Optional',
      year: 'Year',
    },
    form: {
      search_word: {
        label: 'Free word search',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: 'Date issued',
      evaluation_expires_date: 'Date of expiry',
      answer_expires_date: 'Deadline',
      last_updated_date: 'Last updated',
    },
    error: {
      code_0005: 'Authentication failed. Please login again',
      code_0007: 'This question is mandatory',
      code_5001: 'Page not found.',
      code_0001: 'The latest suestionnaire has already been submitted',
      code_0002: 'Update failure because latest data was updated from other device. Please reload and try updating again.',
      code_0003: 'Failed deleting the file. Please delete after answering at least one question.',
      code_0006: 'The user is already registered',
      code_0004: 'This file is exceeding the uploadable file size. Please note that the size must be within 50MB.',
      code_9999: 'An unexpected error happened',
    },
    evaluation: {
      title: 'Request Assessment',
      dashboard: 'Dashboard',
      analysis: 'Analysis',
      list: 'List of companies',
    },
    dashboard: {
      title: 'Dashboard',
    },
    upload: {
      title: 'Survey',
      common: 'Common',
    },
    scorecard: {
      title: 'Score Card',
      list: 'List',
      detail: 'Detail',
      scorecard_detail: 'Score Card Detail',
      answer_preview: 'Answer Preview',
      breadcrumb_detail: 'Company Detail',
    },
    improvementplans: {
      title: 'Improvement Plan',
      detail: '@:common.scorecard.detail',
      breadcrumb_detail: 'Improvement Plan Detail',
    },
    detailExtra: {
      title: 'Advanced analysis',
    },
    settings: {
      title: 'Settings',
    },
    default_selector: {
      selected_label: 'Default',
      do_select:      'Set as default',
      do_release:     'Release as default',
    },
    contact: {
      title: 'FAQs',
    },
    logout: {
      title: 'Log out',
    },
    industry: {
      type_1: 'Agriculture, Forestry, and Fisheries',
      type_2: 'Mining, Quarrying, and Gravel Extraction',
      type_3: 'Construction Industry (Including Facility Construction)',
      type_4: 'Manufacturing Industry (Iron, Steel, Nonferrous Metals, Metal Products)',
      type_5: 'Manufacturing Industry (Machinery, Equipment, Electronics, etc.)',
      type_6: 'Manufacturing Industry (Food, Beverages, Tobacco, etc.)',
      type_7: 'Manufacturing Industry (Pulp, Paper, Paper Products)',
      type_8: 'Manufacturing Industry (Wood, Wood Products Processing)',
      type_9: 'Manufacturing Industry (Chemical Industry, Including Pharmaceuticals, Textile Industry)',
      type_10: 'Manufacturing Industry (Petroleum, Coal, Rubber, Plastic, etc.)',
      type_11: 'Manufacturing Industry (Printing Industry)',
      type_12: 'Manufacturing Industry (Other)',
      type_13: 'Electricity, Gas, Heat Supply, and Water Supply Industry',
      type_14: 'Information and Communication Industry',
      type_15: 'Transportation and Warehousing Industry',
      type_16: 'Wholesale and Retail Industry',
      type_17: 'Financial and Insurance Industry',
      type_18: 'Real Estate Industry',
      type_19: 'Schools (Including Kindergartens and Daycare Centers)',
      type_20: 'Accommodation and Food Services Industry',
      type_21: 'Life-related Services Industry (Laundry, Barber, Beauty, Bathhouse, etc.)',
      type_22: 'Medical and Welfare Industry',
      type_23: 'Waste Disposal and Recycling Industry',
      type_24: 'Automobile Maintenance Industry',
      type_25: 'Local Governments, Public Authorities, etc.',
      type_26: 'Others',
    },
    scale: {
      a: '1〜29 people',
      b: '30〜99 people',
      c: '100〜499 people',
      d: '500〜999 people',
      e: '1000〜4999 people',
      f: 'over 5000 people',
    },
    sales_amount: {
      under_1million: '~1million USD',
      under_10million: '1~10million USD',
      under_100million: '10~100million USD',
      under_1billion: '100million~1billion USD',
      under_10billion: '1~10billion USD',
      over_10billion: '10billion~ USD',
      not_disclose: 'Do not wish to disclose',
    },
    progress: 'Progress',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'Breakdown',
    help: 'Help',
    user_display_mode: {
      my_assessment: 'My assessment',
      supply_chain_assessment: 'Supply chain assessment',
    },
    buyer: 'Buyer',
    supplier: 'Supplier',
    error_page: {
      section_one: 'Page not found',
      section_two: 'Please check the URL',
      to_dashboard: 'Go back to Dashboard',
    },
    priority: {
      good: 'Good',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    priority_full_name: {
      high: 'High risk',
      medium: 'Medium risk',
      low: 'Low risk',
    },
    faq: {
      how_to_use_csv_head: 'To open the downloaded CSV file in Excel, please follow the instructions below.',
      how_to_use_csv_body_01: '1. Open a new blank Excel book.',
      how_to_use_csv_body_02: "2. On the 'Data' tab, click 'From Text or CSV'.",
      how_to_use_csv_body_03: "3. Select a CSV file and click 'Import'.",
      how_to_use_csv_body_04: '4. Confirm that the file has been imported correctly.',
      how_to_use_csv_body_05: "5. Select 'Load'.",
      how_to_use_csv_note: '※ The procedure may vary depending on the operating system and Microsoft Excel version used.',
    },
    answer_display_status: {
      unanswered: 'Not Started',
      temporarily_saved: 'In Progress',
      submitted: 'Submitted',
      score_rated: 'Assessed',
      ended: 'Closed',
      auto_scored: 'Provisionally Scored',
    },
    all: 'All',
    count: {
      question: '',
      company: 'companies',
      unit: 'items',
      number_of_questions_label: 'Number of questions',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      sharing: 'Sharing',
      unshared: 'Unshared',
      inviting: 'Pending',
      viewable: 'Viewable',
      unviewable: 'Unviewable',
    },
    modal: {
      csv_download_mail_sended: {
        title: 'Download accepted',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'Status',
    answer_progress_rate: 'Answer progress rate',
    upper_limit: 'Upper limit',
    lower_limit: 'Lower limit',
    typing: 'Typing',
    notification: {
      send_back: {
        title: 'Your response has been sent back',
        description_1: '{questionGroupName} you answered has been sent back.',
        description_2: 'Please review the contents.',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        title: 'A request to withdraw a response has been received',
        description_1: 'A withdrawal request has been received from {company}.',
        description_2: 'Please review the request and send the response back accordingly.',
        comment_label: 'Withdrawal comment',
      },
      download: {
        csv_success_title: 'CSV file has been successfully generated',
        csv_description_1: 'The data has been compiled into a CSV file.',
        common_description: 'Please click the following URL to download the data.',
        action: 'Download',
        csv_failed_title: 'Failed to generate CSV file',
        failed_description_1: 'Failed to download the data.',
        failed_description_2: 'Please try again after some time.',
        pdf_success_title: 'PDF file has been successfully generated',
        pdf_description_1: 'The data has been compiled into a PDF file.',
        pdf_failed_title: 'Failed to generate PDF file',
        attachment_file_success_title: 'Attachment files are ready',
        attachment_file_description_1: 'Attachment files have been compiled.',
        attachment_file_failed_title: 'Failed to compile attachment files',
        file_number: '{number} file',
      },
      message: {
        title: 'You have received a message',
        description: 'You have received a message from {company} regarding the improvement plan.',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        title: 'A answer master has been shared with you',
        description: 'The following answer master has been shared with you by {name}.',
        person_label: 'Person in charge',
        data_label: '@:esg_data.data_name',
        description_1: 'To view the response data, please verify your email address via the URL below and proceed with the process.',
        description_2: 'The URL is valid for one week. Please complete the process within that time.',
        modal_description: 'Are you sure you want to log out and proceed to email verification?',
      },
      data_share_complete: {
        title: 'You can view the answer master',
        description: 'The following answer data has been shared with you by {name}.',
      },
      answer_remind: {
        title: 'Notification of response deadline',
        description: 'Please review and submit the following {questionGroupName} that you have been asked to answer to.',
      },
      empty_description_1: 'No notifications have been received yet.',
      empty_description_2: 'When a new notification arrives, it will be displayed here.',
      title: 'Notification',
      unread: 'Unread',
    },
    buyer_create_question: {
      title: 'Create Survey',
      create_survey: 'Survey Management',
      answer_list: 'Answer List',
      header_title: 'Buyer-Created Surveys',
    },
    information: {
      not_available: 'This feature is not available yet',
      please_wait: 'Please wait for the feature release',
    },
    action: {
      delete_item: 'Delete {item}',
    },
    category_icon: {
      no_select: 'Do not select',
      water: 'Water',
      waste: 'Waste',
      ghg: 'GHG',
      human_rights: 'Human Rights',
      occupational_safety: 'Occupational Safety',
      security: 'Security',
      balance_scale: 'Balance Scale',
      icon: 'Icon',
      check: 'Check',
    },
    placeholder: {
      input_free: 'Enter',
      half_digits: 'Half-width digits',
    },
    bulk_download_modal: {
      title: 'File Download',
      csv: 'CSV',
      pdf: 'PDF',
      attached_file: '@:improvementplans.attached_file',
      answer_heading: '@:list_table_filter.csv_modal_answer_heading',
      answer_row: 'Row',
      answer_heading_options: {
        company: '@:list_table_filter.csv_modal_answer_heading_supplier',
        question: '@:list_table_filter.csv_modal_answer_heading_question',
      },
      answer_row_options: {
        question: 'Per Question',
        select: 'Per Option',
      },
      target_data_options: {
        question_group: '@:list_table_filter.csv_modal_answer_heading_question',
        answer_status_list: '@:list_table_filter.csv_modal_answer_status_title',
        answer_list_by_individual_company: '@:list_table_filter.csv_modal_answer_title_by_individual_company',
        answer_list: '@:list_table_filter.csv_modal_answer_title',
        score: '@:list_table_filter.csv_modal_score_title',
        improvement_plan: '@:common.improvementplans.title',
      },
      description: 'Download data for "{questionGroupName}".\nSelect target data and output format, then click [Download].',
      target_data: 'Target Data',
      output_type: 'Output Format',
      download_completed: 'File output request has been accepted.\nA file download URL will be sent to your email address, so please wait a moment.\nIf you do not receive an email within 30 minutes, please try again.'
    },
    company: {
      zip_code: 'Postal code',
      zip_code_placeholder: '1050001',
      prefecture: 'Prefecture',
      prefecture_placeholder: 'Tokyo',
      address_one: 'City',
      address_one_placeholder: 'Minato-Ku',
      address_two: 'Address line 1',
      address_two_placeholder: '1-10-5',
      address_three: 'Address line 2',
      address_three_placeholder: 'KDX Toranomon',
    }
  },
};
